var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVaccine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#48AEE2"
    },
    d: "M505.295,107.384c-9.564-9.564-90.807-90.807-100.723-100.723 c-20.162-20.166-50.704,10.333-30.519,30.519l12.239,12.239l-63.94,63.94c-8.428,8.428-8.428,22.091,0,30.519l45.727,45.727 c8.426,8.426,22.091,8.429,30.519,0l63.94-63.94l12.239,12.239C494.772,157.902,525.736,127.826,505.295,107.384z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#39A3DB"
    },
    d: "M505.295,107.384c-11.311-11.311-40.368-40.368-50.361-50.361l-30.519,30.519l-79.199,79.199 l22.864,22.864c8.426,8.426,22.091,8.429,30.519,0l63.94-63.94l12.239,12.239C494.772,157.902,525.736,127.826,505.295,107.384z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#48AEE2"
    },
    d: "M6.321,505.634c-8.428-8.428-8.428-22.091,0-30.519L121.386,360.05 c20.162-20.166,50.704,10.333,30.519,30.519L36.84,505.634C28.415,514.062,14.749,514.063,6.321,505.634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#39A3DB"
    },
    d: "M151.905,360.051L6.321,505.634c8.426,8.428,22.091,8.429,30.519,0L151.905,390.57 C160.333,382.142,160.333,368.478,151.905,360.051z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C7E9F4"
    },
    d: "M454.716,235.551c-6.5-6.5-173.988-173.988-178.313-178.313 c-20.162-20.166-50.704,10.333-30.519,30.519l23.534,23.534L71.025,309.688c-8.428,8.428-8.428,22.091,0,30.519l100.724,100.724 c8.425,8.428,22.091,8.429,30.519,0l198.396-198.397l23.534,23.534C444.361,286.235,474.903,255.736,454.716,235.551z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#80D0E1"
    },
    d: "M454.716,235.551c-8.603-8.603-77.961-77.961-89.156-89.156c-10.1,10.1-234.1,234.1-244.175,244.175 l50.361,50.361c8.425,8.428,22.091,8.429,30.519,0l198.397-198.397l23.534,23.534C444.361,286.235,474.903,255.736,454.716,235.551 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#80D0E1"
    },
    d: "M210.406,170.307l48.831,48.831c20.159,20.162,50.71-10.328,30.519-30.519l-48.831-48.831 L210.406,170.307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#80D0E1"
    },
    d: "M211.424,266.951c20.162,20.165,50.704-10.336,30.519-30.519l-48.831-48.831l-30.519,30.519 L211.424,266.951z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#80D0E1"
    },
    d: "M163.61,314.764c20.162,20.165,50.704-10.336,30.519-30.519l-48.831-48.831l-30.519,30.519 L163.61,314.764z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaccine);
export default __webpack_public_path__ + "static/media/vaccine.4d5d5989bcc58c8d2dabcad70e7b18be.svg";
export { ForwardRef as ReactComponent };